module.exports = __webpack_public_path__ + "img/UserInfoCollection.7467751d.png";